
/* AutoSEM CRO v4: Honest Urgency Messaging on PDP */
(function(){
  if(!document.querySelector('[data-product-form],.product-form,form[action*="/cart/add"]'))return;

  var atcBtn=document.querySelector('button[name="add"],button[type="submit"][data-add-to-cart],.product-form__submit,.btn--add-to-cart');
  if(!atcBtn)return;

  var msg=document.createElement('div');
  msg.className='autosem-urgency';
  msg.style.cssText='margin:12px 0;padding:10px 14px;background:#f0f7f0;border:1px solid #d0e4d0;border-radius:6px;font-size:13px;color:#2d5a27;text-align:center;';
  msg.innerHTML='<strong>&#9997; Made fresh for you</strong> — Ships in 3-5 business days &middot; Free shipping on all orders';

  atcBtn.parentNode.insertBefore(msg,atcBtn.nextSibling);
})();
